
    import {Component, Inject, Vue, Prop} from 'vue-property-decorator';
    import {Validator} from 'vee-validate';
    import { __ } from "@/helpers/utils";

    @Component({
        props: {
            placeholder: String,
            icon: String,
            type: String,
            name: String,
            rules: String,
            value: String,
            label: String,
            options: Array,
            optionsMap: Array,
            selected: String,
        },
    })
    export default class InputSelect extends Vue {

        private translate(term: string) {
            return __(term);
        }

    }
